export function formatDate(dateString: string, format?: string) {
    if (!dateString) return '';
    let d = new Date(dateString);
    let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    let month = new Intl.DateTimeFormat('en', { month: 'long' }).format(d);
    let date = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
    return format === "MMMM yyyy" ?  `${month} ${year}`: `${month} ${date}, ${year}`;
}